export enum AnalysisStep {
  Setup = "Setup",
  Feature = "Feature",
  BusinessMetric = "BusinessMetric",
  Fee = "Fee",
  Summary = "Summary",
}
